<div [ngClass]="{'animate-slide-in-left': currentStep === 1, 'hidden': currentStep !== 1}"
  class="max-w-screen-xl p-6 mx-auto border border-gray-200 shadow-lg bg-white/90 backdrop-blur-md rounded-xl">
  <h2 class="mb-6 text-2xl font-medium text-gray-800">
    Utilisateur à ajouter
  </h2>

  <div class="grid grid-cols-3 gap-8">
    <form class="grid grid-cols-3 col-span-3 gap-6">
      <!-- Nom -->
      <div>
        <label for="nom" class="block mb-2 text-sm font-medium text-gray-800">Nom</label>
        <input type="text" id="nom" placeholder="Nom" name="nom" [(ngModel)]="user.nom"
          class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
      </div>

      <!-- Prénom -->
      <div>
        <label for="prenom" class="block mb-2 text-sm font-medium text-gray-800">Prénom</label>
        <input type="text" id="prenom" placeholder="Prénom" name="prenom" [(ngModel)]="user.prenom"
          class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
      </div>

      <!-- Username -->
      <div>
        <label for="userName" class="block mb-2 text-sm font-medium text-gray-800">Nom
          d'utilisateur</label>
        <input type="text" id="userName" placeholder="Nom d'utilisateur" name="username" [(ngModel)]="user.userName"
          class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
      </div>

      <!-- Email -->
      <div>
        <label for="emailInput" class="block mb-2 text-sm font-medium text-gray-800">Email</label>
        <input type="email" id="emailInput" placeholder="email@exemple.com" name="email" [(ngModel)]="user.email"
          class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
      </div>

      <!-- Mot de passe -->
      <!-- Version avec SVG au lieu de Font Awesome -->
      <div>
        <label for="motDePasse" class="block mb-2 text-sm font-medium text-gray-800">Mot de passe</label>
        <div class="relative">
          <input [type]="showPassword ? 'text' : 'password'" id="motDePasse" placeholder="••••••••" name="passWord"
            [(ngModel)]="user.motDePasse"
            class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pr-10">
          <button type="button" (click)="togglePasswordVisibility()"
            class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-600 hover:text-gray-800">
            <svg *ngIf="!showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            <svg *ngIf="showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
            </svg>
          </button>
        </div>
      </div>

      <div>
        <label for="confirmMotDePasse" class="block mb-2 text-sm font-medium text-gray-800">Confirmer mot de
          passe</label>
        <div class="relative">
          <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmMotDePasse" placeholder="••••••••"
            name="confirmPassWord" [(ngModel)]="confirmMotDePasse"
            class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pr-10">
          <button type="button" (click)="toggleConfirmPasswordVisibility()"
            class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-600 hover:text-gray-800">
            <svg *ngIf="!showConfirmPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            <svg *ngIf="showConfirmPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Message d'erreur mot de passe -->
      <div *ngIf="confirmMotDePasse && confirmMotDePasse !== user.motDePasse"
        class="col-span-3 mt-1 text-sm text-red-600">
        Les mots de passe ne correspondent pas.
      </div>

      <!-- Rôle -->
      <div>
        <label for="role" class="block mb-2 text-sm font-medium text-gray-800">Rôle</label>
        <select id="role" name="roleUser" [(ngModel)]="user.role"
          class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
          <option value>Sélectionnez un rôle</option>
          <option [value]="userRole" *ngFor="let userRole of roleAddable">{{
            userRole }}</option>
        </select>
      </div>

      <!-- Inspection (conditionnel) -->
      <div *ngIf="inspectionFieldActive">
        <label for="inspection" class="block mb-2 text-sm font-medium text-gray-800">Inspection</label>
        <select id="inspection" name="inspectionId" [(ngModel)]="selectedInspection"
          class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
          <option value>Sélectionnez une inspection</option>
          <option [value]="inspection.code" *ngFor="let inspection of inspections">{{ inspection.code
            }}</option>
        </select>
      </div>

      <!-- Bouton Enregistrer -->
      <div class="flex justify-end col-start-3">
        <button type="button" (click)="handleSaveMethod()"
          class="mt-6 flex items-center gap-2 text-white bg-gray-800 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-6 py-2.5 text-center">
          {{ origin=="Modification"?"Modifier":"Enregistrer" }}
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Tableau des utilisateurs -->
<div class="max-w-screen-xl p-6 mx-auto mt-6 border border-gray-200 shadow-lg bg-white/90 backdrop-blur-md rounded-xl">
  <app-datatable [data]="usersInspecteur" [columns]="columns" dataType="Tableau des Utilisateurs"
    routeNavigate="utilisateurs/ajout"></app-datatable>
</div>
